import React from 'react';
import { Empty } from 'antd';
import CoachingAgentStatsPage from '../../pages/CoachingAgentStatsPage';
import WindowNote from './WindowNote';

/**
 * Coaching activity for the campaign, rendered by the page that already computes it.
 *
 * The Campaign Summary is a hub: rather than a second query for the same
 * numbers, this scopes the existing page to the chosen campaign and window.
 * A fix there lands here, and the two cannot drift into disagreeing.
 */
export default function CoachingTab({ campaignId, from, to }) {
  if (!campaignId) {
    return <Empty description="Select a campaign" image={Empty.PRESENTED_IMAGE_SIMPLE} style={{ marginTop: 40 }} />;
  }
  return (
    <>
      <WindowNote from={from} to={to} />
      <CoachingAgentStatsPage embedded campaignId={campaignId} from={from} to={to} />
    </>
  );
}
